module.exports = __webpack_public_path__ + "img/teasers_5.0c93425b.jpg";